import React from 'react'


function Menu(props) {

    return (
        <div >

            <a href='/Overview' className='menu_links'>
                <div className={(props.id === "Overview") ? "menu_div_selected" : "menu_div"}>
                    <i className="bi bi-eye" style={{ paddingRight: "5px" }}></i>
                    Overview
                </div>
            </a>

            <a href='/MapView' className='menu_links'>
                <div className={(props.id === "MapView") ? "menu_div_selected" : "menu_div"}>
                    <i className="bi bi-geo-alt" style={{ paddingRight: "5px" }}></i>
                    Map View
                </div>
            </a>

            <a href='/Sensors' className='menu_links'>
                <div className={(props.id === "Sensors") ? "menu_div_selected" : "menu_div"}>
                    <i className="bi bi-card-list" style={{ paddingRight: "5px" }}></i>
                    Sensors
                </div>
            </a>

            <a href='/Alerts' className='menu_links'>
                <div className={(props.id === "Alerts") ? "menu_div_selected" : "menu_div"}>
                    <i className="bi bi-bell" style={{ paddingRight: "5px" }}></i>
                    Alerts
                </div>
            </a>

            <a href='/Trends' className='menu_links'>
                <div className={(props.id === "Trends") ? "menu_div_selected" : "menu_div"}>
                    <i className="bi bi-graph-up" style={{ paddingRight: "5px" }}></i>
                    Trends
                </div>
            </a>

            <a href='/Settings' className='menu_links'>
                <div className={(props.id === "Settings") ? "menu_div_selected" : "menu_div"}>
                    <i className="bi bi-gear" style={{ paddingRight: "5px" }}></i>
                    Settings
                </div>
            </a>

            <a href='/Logout' className='menu_links'>
                <div className={(props.id === "Logout") ? "menu_div_selected" : "menu_div"}>
                    <i className="bi bi-box-arrow-left" style={{ paddingRight: "5px" }}></i>
                    Logout
                </div>
            </a>



        </div>

    )
}

export default Menu